import React, { useState, useEffect } from 'react';
import { Container, ProgressBarWithoutLabel, ProgressBarWithLabel, CompWrapper, ContentWrapper } from './PTPlusStyled'
import { CircularProgressBarWithoutLabel, CircularProgressBarWithLabel } from "web/components/form-elements/CircularProgressBar";
import { Progress } from 'reactstrap';

import PalletImage from "web/assets/images/palletimage_ptplusadmin.png";
import BasicInfo from './AdminRegisterSteps/BasicInfo'
import FeeStructure from './AdminRegisterSteps/FeeStructure';
import BillTo from './AdminRegisterSteps/BillTo';
import PaymentMethod from './AdminRegisterSteps/PaymentMethod'
import CompletionPage from './AdminRegisterSteps/CompletionPage';

import { Formik } from 'formik';
import { setInitialValues, VALIDATION_SCHEMA } from './AdminRegisterSteps/registerationUtils'

function AdminCreateCustomer(pageProps) {
    const [registrationSteps, setRegistrationSteps] = useState([{ label: 'Create New Customer', progress: 0 },
    { label: 'Bill To', progress: 0 },
    { label: 'Fee Structure', progress: 0 },
    { label: 'Payment & Invoicing', progress: 0 }])
    const [currentStep, setCurrentStep] = useState(1)
    const [overallProgress, setOverallProgress] = useState(0)
    const [tempRegId, setTempRegId] = useState(null)

    useEffect(() => {
        if (pageProps.draftData) {
            let draftedDataTemp = pageProps.draftData
            setTempRegId(draftedDataTemp.id)
            if (draftedDataTemp?.feeStructure?.feeType) nextStep('forward', 'step3')
            else if (draftedDataTemp?.businessInfo?.taxId) nextStep('forward', 'step2')
            else nextStep('forward', 'step1')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const nextStep = (movement, currentStep) => {
        let stepsProgressUpdate = registrationSteps
        if (currentStep === 'step1') {
            if (movement === 'forward') {
                stepsProgressUpdate[0].progress = 100
                stepsProgressUpdate[1].progress = 0
                setCurrentStep(2)
                setOverallProgress(25)
            }
        } else if (currentStep === 'step2') {
            if (movement === 'forward') {
                stepsProgressUpdate[0].progress = 100
                stepsProgressUpdate[1].progress = 100
                stepsProgressUpdate[2].progress = 0
                setCurrentStep(3)
                setOverallProgress(50)
            } else if (movement === 'backward') {
                setCurrentStep(1)
            }
        } else if (currentStep === 'step3') {
            if (movement === 'forward') {
                stepsProgressUpdate[0].progress = 100
                stepsProgressUpdate[1].progress = 100
                stepsProgressUpdate[2].progress = 100
                stepsProgressUpdate[3].progress = 0
                setCurrentStep(4)
                setOverallProgress(75)
            } else if (movement === 'backward') {
                setCurrentStep(2)
            }
        } else if (currentStep === 'step4') {
            if (movement === 'forward') {
                stepsProgressUpdate[3].progress = 100
                setCurrentStep(5)
                setOverallProgress(100)
            } else if (movement === 'backward') {
                setCurrentStep(3)
            }
        }
        setRegistrationSteps(stepsProgressUpdate)
    }

    const skipButtonCall = () => {
        pageProps.setSelectedPage('userLists')
    }

    return (
        <>
            <Container>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                    <div>
                        <p style={{ fontWeight: 'bold', fontSize: '18px' }}>{`Account Setup (${currentStep > 4 ? 4 : currentStep}/4)`}</p>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {registrationSteps.map(val => {
                                return (
                                    <div style={{ margin: '0px 15px 0px 0px' }}>
                                        <p style={{ fontSize: '14px', textAlign: 'center' }}>{val.label}</p>
                                        <Progress value={val.progress} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div style={{ display: 'flex', width: '102px' }}>
                        <ProgressBarWithoutLabel>
                            <CircularProgressBarWithoutLabel />
                        </ProgressBarWithoutLabel>
                        <ProgressBarWithLabel>
                            <CircularProgressBarWithLabel progress={overallProgress} />
                        </ProgressBarWithLabel>
                    </div>
                </div>
            </Container>

            <CompWrapper>
                <div className='main-wrapper'>
                    <div className='image-wrapper'>
                        <img src={PalletImage} alt="PalletImage" />
                    </div>
                    <ContentWrapper>
                        <Formik
                            initialValues={setInitialValues(pageProps.draftData)}
                            validationSchema={VALIDATION_SCHEMA}
                            onSubmit={ _ => { }}>
                            {(props) => {
                                const { setFieldValue } = props;
                                return (
                                    <>
                                        {currentStep === 1 && <BasicInfo nextStepCallBack={nextStep} formikProps={props} skipButtonCall={skipButtonCall} setFieldValue={setFieldValue} tempRegId={tempRegId} tempRegSetFunc={val => setTempRegId(val)} />}
                                        {currentStep === 2 && <BillTo nextStepCallBack={nextStep} formikProps={props} skipButtonCall={skipButtonCall} setFieldValue={setFieldValue} tempRegId={tempRegId} />}
                                        {currentStep === 3 && <FeeStructure nextStepCallBack={nextStep} formikProps={props} skipButtonCall={skipButtonCall} tempRegId={tempRegId} />}
                                        {currentStep === 4 && <PaymentMethod nextStepCallBack={nextStep} formikProps={props} skipButtonCall={skipButtonCall} tempRegId={tempRegId} />}
                                        {currentStep === 5 && <CompletionPage nextStepCallBack={nextStep} formikProps={props} skipButtonCall={skipButtonCall} />}
                                    </>
                                );
                            }}
                        </Formik>
                    </ContentWrapper>
                    <div>
                        <button className='back-button' onClick={skipButtonCall}>Back</button>
                    </div>
                </div>
            </CompWrapper>
        </>
    )
}

export default AdminCreateCustomer
